var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMedunited(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 761,
    height: 760,
    viewBox: "0 0 761 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M455.146 194.269V305.281H606.5V456.92H753.733C758.94 456.92 761 455.432 761 450.454V356.495C761 325.595 742.345 303.164 715.394 303.164H608.617V157.99C608.617 153.241 607.587 151.753 602.38 151.753H501.783C476.891 151.753 455.146 169.664 455.146 194.327",
    fill: "#004C91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 411.944V416.693C3.09001 439.811 24.8917 456.863 48.7534 456.863H151.41V608.273H256.127C285.139 608.273 305.911 588.417 305.911 559.234V454.689H153.528V303.049H0V411.886V411.944Z",
    fill: "#004C91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M303.793 42.8022V151.696H151.353V262.708C151.353 285.597 174.185 305.281 196.959 305.281H303.736V153.871H450.969C456.176 153.871 457.207 152.383 457.207 147.405V6.52325C457.207 1.54491 456.176 0.0571289 450.969 0.0571289H348.312C325.481 0.0571289 303.736 19.7416 303.736 42.8022",
    fill: "#004C91"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.146 606.385H303.793V753.504C303.793 758.482 304.823 759.97 310.03 759.97H397.123C432.372 759.97 457.264 745.722 457.264 708.756V606.385H608.617V503.786C608.617 490.625 603.409 477.635 598.259 470.311C592.022 462.986 579.605 454.746 566.1 454.746H455.146V606.385Z",
    fill: "#004C91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMedunited);
export default __webpack_public_path__ + "static/media/Logo_medunited.cad011c398f01f4fa69746985a1a5a2d.svg";
export { ForwardRef as ReactComponent };